import {Component, model} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';

@Component({
    selector: 'app-logo-ddh',
    imports: [
        NgOptimizedImage
    ],
    templateUrl: './logo-ddh.component.html',
    styleUrl: './logo-ddh.component.scss'
})
export class LogoDdhComponent {
  dark = model<boolean>(false);
}
